// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import styles from '@app/features/guild/components/modals/GuildOwnershipWarningModal.module.css';
import {GuildIcon} from '@app/features/guild/components/popouts/GuildIcon';
import type {Guild} from '@app/features/guild/models/Guild';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

interface GuildOwnershipWarningModalProps {
	ownedGuilds: Array<Guild>;
}
export const GuildOwnershipWarningModal: React.FC<GuildOwnershipWarningModalProps> = observer(({ownedGuilds}) => {
	const {t} = useLingui();
	const displayedGuilds = ownedGuilds.slice(0, 3);
	const remainingCount = ownedGuilds.length - 3;
	return (
		<Modal.Root size="small" centered>
			<Modal.Header title={t`Cannot Delete Account`} />
			<Modal.Content>
				<div className={styles.content}>
					<p>
						<Trans>
							You cannot delete your account while you own communities. Please transfer ownership of the following
							communities first:
						</Trans>
					</p>
					<div className={styles.guildList}>
						{displayedGuilds.map((guild) => (
							<div key={guild.id} className={styles.guildItem}>
								<GuildIcon id={guild.id} name={guild.name} icon={guild.icon} className={styles.guildIcon} sizePx={40} />
								<div className={styles.guildInfo}>
									<div className={styles.guildName}>{guild.name}</div>
								</div>
							</div>
						))}
						{remainingCount > 0 && (
							<div className={styles.remainingCount}>
								<Trans>and {remainingCount} more</Trans>
							</div>
						)}
					</div>
					<p className={styles.helpText}>
						<Trans>
							To transfer ownership, go to Community Settings → Overview and use the Transfer Ownership option.
						</Trans>
					</p>
				</div>
			</Modal.Content>
			<Modal.Footer>
				<Button onClick={ModalCommands.pop}>
					<Trans>OK</Trans>
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
});
